import React from 'react'
import { Container, Grid, Hidden, withStyles } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { fade } from '@material-ui/core/styles/colorManipulator'
import range from 'lodash/range'

import { colors } from 'theme'

const Content = ({ classes }) => (
  <Container maxWidth="md" className={classes.container}>
    <Grid container>
      <Hidden xsDown>
        <Grid item sm={4}>
          <Skeleton
            animation="wave"
            variant="rect"
            height={400}
            width={280}
            className={classes.drawer}
          >
            {range(12).map(index => (
              <Grid container key={index} spacing={2}>
                <Grid item>
                  <Skeleton
                    key={`${index}circle`}
                    variant="circle"
                    width={24}
                    height={24}
                    style={{
                      backgroundColor: fade(colors.black, 0.03),
                    }}
                  />
                </Grid>
                <Grid item>
                  <Skeleton
                    key={`${index}text`}
                    variant="text"
                    width={130}
                    style={{
                      backgroundColor: fade(colors.black, 0.03),
                    }}
                  />
                </Grid>
              </Grid>
            ))}
          </Skeleton>
        </Grid>
      </Hidden>
      <Grid item xs={12} sm={8} className={classes.textContainer}>
        <Skeleton
          animation="wave"
          variant="rect"
          width="50%"
          height={28}
          style={{
            marginBottom: 40,
            backgroundColor: fade(colors.gray900, 0.1),
          }}
        />
        {range(20).map(index => (
          <Skeleton
            key={index}
            variant="text"
            width="80%"
            animation="wave"
            style={{
              backgroundColor: fade(colors.gray900, 0.05),
            }}
          />
        ))}
      </Grid>
    </Grid>
  </Container>
)

const styles = theme => ({
  container: {
    padding: theme.spacing(5, 0),
    backgroundColor: '#FFF',
    height: 500,
    maxHeight: '100vh',
    [theme.breakpoints.only('xs')]: {
      padding: theme.spacing(5, 2),
    },
  },
  drawer: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    padding: 20,
    maxWidth: 'calc(100vw / 3 * 0.9)',
  },
})

export default withStyles(styles)(Content)
